import React from 'react';
import Select, { components } from 'react-select';

const { ValueContainer, Placeholder } = components;

const CustomValueContainer = ({ children, ...props }) => {
    return (
        <ValueContainer {...props}>
            <Placeholder {...props} isFocused={props.isFocused}>
                {props.selectProps.placeholder}
            </Placeholder>
            {React.Children.map(children, (child) =>
                child && child.type !== Placeholder ? child : null
            )}
        </ValueContainer>
    );
};


const SelectField = ({ options, placeholder, name, onChange, isSearchable, isDisabled, required, value, onBlur, tabIndex }) => {

    return (
        <div className={required ? "select-required" : ""}>
            <Select
                className="select-form"
                name={name}
                id={name}
                options={options}
                components={{
                    ValueContainer: CustomValueContainer
                }}
                isSearchable={isSearchable}
                isDisabled={isDisabled}
                value={value}
                placeholder={placeholder}
                onChange={onChange}
                onBlur={onBlur}
                tabIndex={tabIndex}

                styles={{
                    valueContainer: (provided, state) => ({
                        ...provided,
                        overflow: "visible"
                    }),
                    placeholder: (provided, state) => ({
                        ...provided,
                        position: "absolute",
                        paddingRight: 3,
                        paddingLeft: 3,
                        top: state.hasValue || state.selectProps.inputValue ? -11 : "13%",
                        backgroundColor:
                            state.hasValue || state.selectProps.inputValue
                                ? "var(--ComponentBgColor)"
                                : "transparent",
                        zIndex: 2,
                        color: "var(--slate500Color)",
                        transition: "top 0.3s, font-size 0.3s",
                        fontSize: (state.hasValue || state.selectProps.inputValue) && 12
                    })
                }}
            />
        </div>
    )
}


export default SelectField
